import { useContext, useEffect, useRef, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { AppState } from 'App';
import { useAuth } from 'context/AuthContext'

import { Loading } from 'components/misc/Icons'

export default function Login() {

    const [appState, setAppState] = useContext(AppState)

    const [showLanguages, setShowLanguages] = useState(false)
    const [t, i18n] = useTranslation('common');

    const node = useRef();
    const emailRef = useRef()
    const passwordRef = useRef()

    const { login, googleLogin } = useAuth()

    const history = useHistory()

    const handleClickOutside = e => {
        if (node.current.contains(e.target)) {
            // inside click
            return;
        }
        setShowLanguages(false);
    };

    useEffect(() => {
        if (showLanguages) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showLanguages]);

    async function handleEmailSubmit(e) {
        e.preventDefault()
        setAppState(prevState => ({...prevState,loadingContext:true}))
        try {
            await login(emailRef.current.value, passwordRef.current.value)
            history.push("/")
        }
        catch {
            console.log('Failed to login. Please try again.')
        }
        finally {
            setAppState(prevState => ({...prevState,loadingContext:null}))
            console.log('form submitted')
        }
    }

    async function handleGoogleLogin() {
        setAppState(prevState => ({...prevState,loadingContext:true}))
        try {
            await googleLogin()
        }
        catch {
            console.log("Error with Google SignUp")
        }
        finally {
            setAppState(prevState => ({...prevState,loadingContext:null}))
            history.push("/")
        }
    }

    return (
        <>
            <div>
                <button
                    ref={node}
                    onClick={e => setShowLanguages(!showLanguages)}
                    className="relative mt-2 text-xs text-textlight">{t('LanguageSelector')}
                    {showLanguages===true ? (
                    <div className="absolute mt-2">
                        <div className="flex flex-col w-48 py-2 space-y-2 border rounded-lg bg-itemlight border-borderlight z-1100">
                            <button
                                onClick={() => i18n.changeLanguage('id')}
                                className="h-10 px-2 text-base font-light text-left transition-colors duration-200 transform text-text-light hover:bg-itemdark hover:text-white">Bahasa Indonesia</button>
                            <button
                                onClick={() => i18n.changeLanguage('de')}
                                className="h-10 px-2 text-base font-light text-left transition-colors duration-200 transform text-text-light hover:bg-itemdark hover:text-white">Deutsch</button>
                            <button
                                onClick={() => i18n.changeLanguage('en')}
                                className="h-10 px-2 text-base font-light text-left transition-colors duration-200 transform text-text-light hover:bg-itemdark hover:text-white">English (UK)</button>
                        </div>
                    </div>
                ) : (
                    null
                )}
                </button>
            </div>
            <h1 className="mt-12 text-2xl font-semibold tracking-tighter text-itemdark sm:text-3xl title-font">{t('LItitle')}</h1>
                <form className="mt-6" onSubmit={handleEmailSubmit}>
                    <div>
                        <label className="block text-sm font-medium leading-relaxed tracking-tighter text-gray-700">{t('SUformemail')}</label>
                        <input type="email" placeholder={t('emailplaceholder')} ref={emailRef}
                            className="w-full px-4 py-2 mt-2 text-base border-transparent rounded-lg text-itemdark focus:border-gray-500 focus:bg-white focus:ring-0 "
                            autoFocus autoComplete required/>
                    </div>
                    <div className="mt-4">
                        <label className="block text-sm font-medium leading-relaxed tracking-tighter text-gray-700">{t('SUformp1')}</label>
                        <input type="password" placeholder={t('passwordplaceholder')} minLength="6" ref={passwordRef}
                            className="w-full px-4 py-2 text-base border-transparent rounded-lg text-itemdark focus:border-gray-500 focus:bg-white focus:ring-0"
                            required/>
                    </div>
                    <div className="mt-2 text-right">
                        <Link to="/access/forgot-password" className="text-sm font-semibold leading-relaxed text-gray-700 hover:text-itemdark focus:text-hoverdark">{t('LIforgot')}</Link>
                    </div>
                    <button
                        type="submit"
                        className="block w-full px-4 py-3 mt-6 font-semibold text-white transition duration-200 ease-in-out transform rounded-lg bg-itemdark focus:shadow-outline focus:outline-none hover:bg-hoverdark"
                        >{!appState.loadingContext ? 'Log In' : <Loading width={4} height={4} stroke={3} />}
                        </button>
                </form>
                <hr className="w-full my-6 border-gray-300"/>
                <div className="flex justify-enter">
                    <button type="button"
                        onClick={handleGoogleLogin}
                        className="inline-flex justify-center w-full px-4 py-3 font-semibold transition duration-200 border-gray-300 rounded-lg text-itemdark bg-blue-1300 hover:bg-itemdark hover:text-white focus:bg-gray-100">
                        <div className="flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg"
                                className="w-6 h-6" viewBox="0 0 48 48">
                                <defs>
                                    <path id="a"
                                        d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" />
                                </defs>
                                <clipPath id="b">
                                    <use href="#a" overflow="visible" />
                                </clipPath>
                                <path clipPath="url(#b)" fill="#FBBC05" d="M0 37V11l17 13z" />
                                <path clipPath="url(#b)" fill="#EA4335" d="M0 11l17 13 7-6.1L48 14V0H0z" />
                                <path clipPath="url(#b)" fill="#34A853" d="M0 37l30-23 7.9 1L48 0v48H0z" />
                                <path clipPath="url(#b)" fill="#4285F4" d="M48 48L17 24l-4-3 35-10z" />
                            </svg>
                            <span className="ml-4">{t('LIgoogle')}</span>
                        </div>
                    </button>
                    {/* <button type="button"
                        className="inline-flex px-4 py-3 ml-8 font-semibold text-blue-700 border border-gray-300 rounded-lg bg-blue-1300 hover:bg-blue-700 focus:bg-gray-100 hover:text-blue-500">
                        <div className="flex items-center justify-center">
                            <svg fill="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                className="w-5 h-5" viewBox="0 0 24 24">
                                <path
                                    d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z">
                                </path>
                            </svg>
                        </div>
                    </button> */}
                </div>
                <p className="mt-8 text-center">{t('LIneedaccount')}&nbsp;
                    <Link to="/signup" className="font-semibold text-itemdark hover:text-hoverdark">{t('SUtitle')}</Link>
                </p>
        </>
    )
}
